export function Checkbox({ checked, onCheckedChange, className = "", disabled, ...props }) {
  return (
    <input
      type="checkbox"
      checked={!!checked}
      disabled={disabled}
      onChange={(event) => onCheckedChange?.(event.target.checked)}
      className={`h-4 w-4 rounded border ${className}`}
      {...props}
    />
  );
}
